const BOOKING_CTA_CLASS = 'gtmBookingCta';
const SURVEY_CTA_CLASS = 'gtmSurveyCta';
const FAQ_TOGGLE_CLASS = 'gtmFaqToggleButton';
const LOCATIONS_DROPDOWN_CLASS = 'gtmToggleLocationDropdown';

const HEADER_CTA_EVENT = 'CTA header';

const BOOKING_EVENT_CATEGORY = 'Booking funnel';

export {
  BOOKING_CTA_CLASS,
  BOOKING_EVENT_CATEGORY,
  HEADER_CTA_EVENT,
  SURVEY_CTA_CLASS,
  FAQ_TOGGLE_CLASS,
  LOCATIONS_DROPDOWN_CLASS,
};
